import type { VoteMap, PollSettings } from './utils';

/**
 * Toggle vote state for a slot/option.
 * Replicates the logic from apps/web/src/lib/services/vote-service.ts
 */
export function toggleVote(
	slotId: string,
	currentVotes: VoteMap,
	settings: PollSettings
): VoteMap {
	const newVotes = { ...currentVotes };
	const current = newVotes[slotId];
	const allowMaybe = settings.allow_maybe ?? true;
	const singleSelection = settings.single_selection ?? false;

	if (singleSelection) {
		// If clicking on already selected item, deselect it
		if (current === 'yes' || current === 'maybe') {
			delete newVotes[slotId];
		} else {
			// Clear all other votes and select this one
			for (const key of Object.keys(newVotes)) {
				delete newVotes[key];
			}
			newVotes[slotId] = 'yes';
		}
	} else {
		// Normal multi-selection toggle: no/undefined → yes → maybe (if allowed) → no
		if (!current || current === 'no') {
			newVotes[slotId] = 'yes';
		} else if (current === 'yes' && allowMaybe) {
			newVotes[slotId] = 'maybe';
		} else {
			newVotes[slotId] = 'no';
		}
	}

	return newVotes;
}
